import { gql } from '@apollo/client';

const FIELDS = gql`
  fragment fields on User {
    _id
    email
    name
    firstName
    password
    activationCode
    active
    role {
      _id
      name
      class
    }
    profileImage
    preferredLanguage
  }
`;

export const ADD_CONTACT = gql`
  mutation addContact($psychologist: String!) {
    addContact(psychologist: $psychologist)
  }
`;

export const CREATE_ONE_SIGNAL_USER = gql`
  mutation createOneSignalUser($body: String!) {
    createOneSignalUser(body: $body)
  }
`;

export const ADD_ONE_SIGNAL_TAGS = gql`
  mutation addTags($body: String!) {
    addTags(body: $body)
  }
`;

export const SET_REGION = gql`
  mutation setRegion($region: String!) {
    setRegion(region: $region) {
      _id
    }
  }
`;

export const SET_ONBOARDING_DONE = gql`
  mutation setOnboardingDone {
    setOnboardingDone
  }
`;

export const SET_REDO_SESSION_DONE = gql`
  mutation setRedoSessionDone {
    setRedoSessionDone
  }
`;

export const SET_TIMEZONE = gql`
  mutation setTimeZone($timeZone: String!) {
    setTimeZone(timeZone: $timeZone) {
      _id
    }
  }
`;

export const register = gql`
  mutation register(
    $firstName: String!
    $email: String!
    $password: String!
    $locale: String!
    $recaptcha: String!
    $link: String!
    $registrationCode: String!
  ) {
    register(
      firstName: $firstName
      email: $email
      password: $password
      locale: $locale
      recaptcha: $recaptcha
      link: $link
      registrationCode: $registrationCode
    )
  }
`;

export const CREATE_ANONYMOUS = gql`
  mutation anonyme($reckoning: String!) {
    createAnonymous(reckoning: $reckoning)
  }
`;

export const SET_ACTIVE_PATH = gql`
  mutation setActivePath($pathId: String!) {
    setActivePath(pathId: $pathId)
  }
`;

export const SET_VISITED_PAGE = gql`
  mutation setVisitedPages($page: VisitedPages!) {
    setVisitedPages(page: $page)
  }
`;

export const REGISTER_ANONYMOUS = gql`
  mutation registerFromAnonymous($firstName: String!, $email: String!, $password: String!) {
    registerFromAnonymous(firstName: $firstName, email: $email, password: $password)
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      ...fields
    }
  }
  ${FIELDS}
`;

export const feedback = gql`
  mutation feedback($feedback: String!, $anonimity: Boolean!) {
    feedback(feedback: $feedback, anonimity: $anonimity)
  }
`;

export const FEEDBACK_WHEN_CHANGING_PROGRAM = gql`
  mutation feedbackWhenChangingProgram($feedback: feedbackWhenChangingProgramInput!) {
    feedbackWhenChangingProgram(feedback: $feedback)
  }
`;

export const FEEDBACK_WITH_JSON = gql`
  mutation feedbackWithJson($feedback: String!) {
    feedbackWithJson(feedback: $feedback)
  }
`;

export const DELETE_ACCOUNT_AND_DATA = gql`
  mutation deleteAccountAndData {
    deleteAccountAndData
  }
`;

export const UPDATE = gql`
  mutation updateUser($input: UserUpdateInput!) {
    updateUser(input: $input) {
      ...fields
    }
  }
  ${FIELDS}
`;

export const LOGIN = gql`
  mutation login($email: String!, $password: String!, $elliToken: String) {
    login(email: $email, password: $password, elliToken: $elliToken)
  }
`;

export const SILENT_LOGIN = gql`
  mutation silentLogin {
    silentLogin
  }
`;

export const STORE_ELLI_TOKEN = gql`
  mutation storeElliToken($elliToken: String!) {
    storeElliToken(elliToken: $elliToken)
  }
`;

export const ASK_RECOVER = gql`
  mutation askRecover($email: String!) {
    askRecover(email: $email)
  }
`;

export const SET_EVOLUTIME = gql`
  mutation setEvolutime($active: Boolean!, $daysOfWeek: [Boolean!]!, $hour: Float!, $minute: Float!) {
    setEvolutime(active: $active, daysOfWeek: $daysOfWeek, hour: $hour, minute: $minute) {
      active
      daysOfWeek
      hour
      minute
    }
  }
`;

export const RESEND_CODE = gql`
  mutation resendCode($email: String!) {
    resendCode(email: $email)
  }
`;

export const WPO_UNLOCK_COUNSELLOR = gql`
  mutation unlock($input: UnlockCounsellorInput!) {
    wpoUnlockCounsellor(input: $input)
  }
`;

export const WPO_CANCEL_APPOINTMENT = gql`
  mutation cancel($input: CancelAppointmentInput!) {
    wpoCancelAppointment(input: $input) {
      message
      status
    }
  }
`;

export const GET_FACE_SCAN_URL = gql`
  mutation getFaceScanUrl($language: String!) {
    url: getFaceScanUrl(language: $language)
  }
`;

export const GET_HEALTH_DASHBOARD_URL = gql`
  mutation getHealthDashboardUrl($language: String!) {
    url: getHealthDashboardUrl(language: $language)
  }
`;

export const HAS_FACE_SCAN_RESULTS = gql`
  mutation hasFaceScanResults {
    hasFaceScanResults
  }
`;
